import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Notification from 'components/Notification.js';
import NotificationTypes from 'constants/NotificationTypes';
import PropTypes from 'prop-types';

import {
  faCheckCircle,
  faExclamationCircle
} from '@fortawesome/free-solid-svg-icons';

import styled from 'styled-components';

const NotificationWrapper = styled.div`
  position: fixed;
  top: 16px;
  left: 0;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  transition: opacity 0.5s;

  opacity: ${props => (props.show ? 1 : 0)};

  pointer-events: ${props => (props.show ? 'all' : 'none')};

  z-index: 15;
`;

const NotificationItem = ({ notification, history }) => {
  const { message, options } = notification;

  if (
    !options ||
    !options.type ||
    options.type === NotificationTypes.ShowResetTimes
  ) {
    return (
      <Notification type="success" icon={faCheckCircle} message={message} />
    );
  } else if (
    options &&
    options.type === NotificationTypes.DuplicateShowToEvent
  ) {
    const { eventId, teamId } = options;

    return (
      <Notification
        type="success"
        icon={faCheckCircle}
        message={message}
        linkMessage="Go to event."
        onClick={() => history.push(`/dash/team/${teamId}/event/${eventId}`)}
      />
    );
  } else if (
    options &&
    options.type === NotificationTypes.MovedEventTemplateToTeam
  ) {
    const { teamId } = options;

    return (
      <Notification
        type="success"
        icon={faCheckCircle}
        message={message}
        linkMessage="View Library."
        onClick={() => history.push(`/dash/team/${teamId}/templates`)}
      />
    );
  } else {
    return (
      <Notification icon={faExclamationCircle} message={message} {...options} />
    );
  }
};

NotificationItem.propTypes = {
  notification: PropTypes.object.isRequired,
  history: PropTypes.object
};

const Notifications = ({ notification, history }) => {
  return (
    <NotificationWrapper show={notification.length}>
      {notification.map((item, index) => {
        return (
          <NotificationItem key={index} notification={item} history={history} />
        );
      })}
    </NotificationWrapper>
  );
};

Notifications.propTypes = {
  notification: PropTypes.array.isRequired,
  history: PropTypes.object
};

export default withRouter(
  connect(({ notification }) => {
    return { notification };
  }, {})(Notifications)
);
